import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import helpEn from "./en/help.json";
import helpDe from "./de/help.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: helpEn,
      },
      de: {
        translation: helpDe,
      },
    },
    lng: localStorage.getItem("betty-language") || "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export function setBettyLanguage(language) {
  localStorage.setItem("betty-language", language);
  return i18n.changeLanguage(language);
}

export default i18n;
